import React, { useState, useEffect } from "react";
import Search from "../../../../Header/Search/Search";
import ApplicableForSelectList from "../ApplicableForSelectListingComp/ApplicableForSelectList";
import useAxiosPrivate from "../../../../../hooks/useAxiosPrivate";
import SpinnerLoader from "../../../../PageLoader/SpinnerLoader";
import { shiftTagTypes } from "../../../../../Consts/consts";

const emptyState = <p>No Data Found...</p>;

const ApplicableForEmpTypeSelectComp = ({
  handleChangeApplicableFor,
  applicableForData,
}) => {
  const axiosPrivate = useAxiosPrivate();
  const [emploeeTypeList, setEmployeeTypeList] = useState([]);
  const [loaderComponent, setLoaderComponent] = useState(<SpinnerLoader />);
  const [searchValue, setSearchValue] = useState("");
  const [baseUrl, setBaseUrl] = useState("employee/getEmployeeTypeList");

  const getSearchValue = (data) => {
    setSearchValue(data);
  };

  const fetchEmployeeTypeList = async () => {
    setLoaderComponent(<SpinnerLoader />);
    let isMounted = true;
    const controller = new AbortController();
    await axiosPrivate
      .get(baseUrl, {
        signal: controller.signal,
      })
      .then((response) => {
        const { data } = response;
        if (data.status) {
          setEmployeeTypeList(data.result);
          setLoaderComponent(null);
        } else {
          setLoaderComponent(emptyState);
        }
      })
      .catch((err) => {
        setLoaderComponent(emptyState);
      });

    return () => {
      isMounted = false;
      controller.abort();
    };
  };

  useEffect(() => {
    let baseUrl = `employee/getEmployeeTypeList`;

    if (searchValue) {
      const delayTimer = setTimeout(() => {
        baseUrl = baseUrl + `?filter=${searchValue}`;
        setBaseUrl(baseUrl);
      }, 600);
      return () => {
        clearTimeout(delayTimer);
      };
    }
  }, [searchValue]);

  useEffect(() => {
    fetchEmployeeTypeList();
  }, [baseUrl]);

  const handleSelectAll = (e) => {
    if (emploeeTypeList.length) {
      emploeeTypeList.forEach((i, index) => {
        handleChangeApplicableFor({
          status: e.target.checked,
          referenceId: i.id,
          tag: shiftTagTypes.employeeType,
          title: i.type_label,
          photo: i.photo || null,
          uniqueId: `employee_type_${index}`,
        })
      })
    }
  }

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-3">
        <input type="checkbox" onClick={handleSelectAll}/>
        <p className="flex items-center gap-2">
          <Search onChange={getSearchValue} mx={"0"} />
        </p>
      </div>
      {loaderComponent ? (
        <div className="flex justify-center items-center h-[150px]">
          {loaderComponent}
        </div>
      ) : null}
      {emploeeTypeList.length
        ? emploeeTypeList.map((item, index) => {
            const isExist = !!applicableForData.find(
              (data) =>
                data.referenceId === item.id && data.tag === "employee type"
            );
            return (
              <ApplicableForSelectList
                handleChangeApplicableFor={handleChangeApplicableFor}
                tag={shiftTagTypes.employeeType}
                referenceId={item.id}
                title={item.type_label}
                isExist={isExist}
                key={`employee_type_${index}`}
                uniqueId={`employee_type_${index}`}
              />
            );
          })
        : null}
    </div>
  );
};

export default ApplicableForEmpTypeSelectComp;
